import axios from 'axios';
import Vue from 'vue';

import { SYSTEM_VARIABLE } from '../modules/Application';
import { getToken } from './token';

export default (version = 1) => {
  const http = axios.create({
    baseURL: `${SYSTEM_VARIABLE.BASE_URL_API}/rpc/v${version}/`,
    headers: {
      Accept: 'application/json, text/plain, */*',
      'Accept-Language': 'pt_BR',
    },
  });

  http.interceptors.request.use(async (config) => ({
    ...config,
    headers: {
      ...config.headers,
      'Authorization-Compufacil': await getToken(),
    },
  }));

  http.interceptors.response.use(
    (response) => response,
    async (error) => {
      const token = await getToken();
      if (token) {
        Vue.$toast.open({
          message: error.response.data.error_message,
          type: 'error',
          duration: 2000,
        });
      }
      return Promise.reject(error);
    },
  );
  return http;
};
